import { EllipsedText, FlexRow, MaterialIcon } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { LabelMedium } from 'baseui/typography';
import { memo } from 'react';
import { useCamera } from '../../../hooks/useCamera';
import { useStyles } from '../../../hooks/useStyles';
import { LiveStatusDetail } from '../../../types/liveStatus';
import { StyledTooltip } from '../../ui/StyledTooltip';

type Props = {
  liveStatusDetail: LiveStatusDetail;
};
function DetailCardHeader({ liveStatusDetail }: Readonly<Props>) {
  const { theme, css } = useStyles();
  const { zoomTo } = useCamera();

  return (
    <FlexRow
      classNames={css({
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: `${theme.sizing.scale500} ${theme.sizing.scale600}`,
      })}
    >
      <FlexRow
        gap={theme.sizing.scale200}
        classNames={css({ flexGrow: '1' })}
      >
        <StyledTooltip content={'Etiqueta'}>
          <LabelMedium>
            <EllipsedText
              breakAll
              inline
            >
              {liveStatusDetail.label}
            </EllipsedText>
          </LabelMedium>
        </StyledTooltip>
      </FlexRow>
      <StyledTooltip
        content="Encontrar en el mapa"
        showArrow={false}
        placement="bottom"
        ignoreBoundary
      >
        <Button
          shape="circle"
          kind="tertiary"
          size="mini"
          onClick={() =>
            zoomTo({ lat: liveStatusDetail.point.coordinates[1], lng: liveStatusDetail.point.coordinates[0] })
          }
        >
          <MaterialIcon
            name="location_searching"
            size="16px"
          />
        </Button>
      </StyledTooltip>
    </FlexRow>
  );
}

export default memo(DetailCardHeader);
